<mat-autocomplete (optionSelected)="onOptionSelected($event.option.value)"
                  class="full-width-options">
  @for (prompt of options(); track $index) {
    <mat-option [value]="prompt">
      <div class="row eva-smart-question">
        <mat-icon svgIcon="eva"
                  color="accent" />
        <span>{{ prompt }}</span>
        <mat-icon class="eva-smart-question-selector">arrow_forward</mat-icon>
      </div>
    </mat-option>
  }
</mat-autocomplete>
